<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { SUPPORTED_LOCALES, LOCALE_LABELS, setI18nLocale, normalizeLocale } from '@/i18n'

const { locale } = useI18n({ useScope: 'global' })
const current = computed({
    get: () => normalizeLocale(locale.value),
    set: (value: string) => {
        setI18nLocale(value)
    },
})
</script>

<template>
    <select
        v-model="current"
        class="text-sm"
        style="
            background-color: transparent;
            color: var(--color-ink-base);
            border: 1px solid var(--color-border-subtle);
            border-radius: 4px;
            padding: 2px 6px;
        "
        :aria-label="$t('settings.language')">
        <option v-for="loc in SUPPORTED_LOCALES" :key="loc" :value="loc">
            {{ LOCALE_LABELS[loc] }}
        </option>
    </select>
</template>
